import {HttpClient} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {forkJoin, Observable} from 'rxjs';

import {Dimension} from '@selpia/shared/models';

import {ParametersDto} from '../dtos';

@Injectable({
  providedIn: 'root',
})
export class AppConfigService {
  readonly #http: HttpClient = inject(HttpClient);
  readonly #url: string = S2WX_API_URL;

  getConfig(): Observable<[Dimension[], ParametersDto]> {
    return forkJoin([this.#getDimensions(), this.#getParams()]);
  }

  #getDimensions(): Observable<Dimension[]> {
    return this.#http.get<Dimension[]>(`${this.#url}/Dimensions`);
  }

  #getParams(): Observable<ParametersDto> {
    return this.#http.get<ParametersDto>(`${this.#url}/Parameters`);
  }
}
